import { Injectable } from '@angular/core';
import { DeadlinesData, DeadlinesTimeline } from '@core/interfaces';
import { ReportsService } from '../../reports.service';
import { DeadlinesApi } from './api/deadlines-api.service';
import { DeadlinesMapperService } from './deadlines.mapper.service';

@Injectable({
  providedIn: 'root'
})
export class DeadlinesResolverService {
  constructor(
    private api: DeadlinesApi,
    private mapper: DeadlinesMapperService,
    private reportsService: ReportsService
  ) { }

  public async getAverageDeadlinesAndTimeline({
    footerWhere,
    currentWhere,
    responsePeriod,
    solutionPeriod
  }): Promise<any[]> {
    const toPromise = [];

    const averageDeadlines = this.getAverageDeadlines({
      currentWhere,
      footerWhere
    });

    const responseTimeline = this.getTimeline({
      where: currentWhere,
      timelineOption: responsePeriod,
    });

    toPromise.push(averageDeadlines, responseTimeline);
    if (responsePeriod !== solutionPeriod) {
      const solutionTimeline = this.getTimeline({
        where: currentWhere,
        timelineOption: solutionPeriod
      });

      toPromise.push(solutionTimeline);
    }

    return Promise.all(toPromise);
  }

  public async getAverageDeadlines({ currentWhere, footerWhere }): Promise<DeadlinesData> {
    const [footerPeriod, currentPeriod] = await Promise.all([
      this.reportsService.getAverageDeadlines(footerWhere).toPromise(),
      this.reportsService.getAverageDeadlines(currentWhere).toPromise()
    ]);

    return {
      footerPeriod,
      currentPeriod
    };
  }

  public async getTimeline({ where, timelineOption }): Promise<DeadlinesTimeline[]> {
    const whereInput = this.mapper.toTimelineWhere({ where, timelineOption });
    return this.api.getResponseDeadlinesTimeline(whereInput).toPromise();
  }
}
